import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemSection } from './components/ProblemSection';
// Lazy load below-fold sections to reduce initial JS bundle
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BeforeAfterSection = lazy(() => import('./components/BeforeAfterSection').then(m => ({
  default: m.BeforeAfterSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UpsellTransition = lazy(() => import('./components/UpsellTransition').then(m => ({
  default: m.UpsellTransition
})));
const MockupComparison = lazy(() => import('./components/MockupComparison').then(m => ({
  default: m.MockupComparison
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const DecisionBox = lazy(() => import('./components/DecisionBox').then(m => ({
  default: m.DecisionBox
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalClose = lazy(() => import('./components/FinalClose').then(m => ({
  default: m.FinalClose
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
    requestIdleCallback?: (cb: () => void) => number;
  }
}
function initMetaPixel() {
  const f: any = window;
  const b = document;
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  const t = b.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  b.head.appendChild(t);
  f.fbq('init', '1688179945683486');
  f.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    // Defer Meta Pixel to not block initial render
    if (window.requestIdleCallback) {
      window.requestIdleCallback(initMetaPixel);
    } else {
      setTimeout(initMetaPixel, 2000);
    }
    // Add preconnect for CDN to speed up image loading
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://cdn.magicpatterns.com';
    document.head.appendChild(preconnect);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-yellow-200" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <Suspense fallback={null} data-id="element-5">
        <SolutionSection data-id="element-6" />
        <TomosSection data-id="element-7" />
        <BeforeAfterSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <BonusSection data-id="element-10" />
        <UpsellTransition data-id="element-11" />
        <MockupComparison data-id="element-12" />
        <PricingSection data-id="element-13" />
        <DecisionBox data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalClose data-id="element-17" />
        <Footer data-id="element-18" />
        <SocialProofPopup data-id="element-19" />
      </Suspense>

      {/* Meta Pixel Noscript */}
      <noscript data-id="element-20">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1688179945683486&ev=PageView&noscript=1" data-id="element-21" />
      </noscript>
    </div>;
}